import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable, Injector } from "@angular/core";

import { environment } from './../../../environments/environment';
import { AuthService } from './../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService = this.injector.get(AuthService);

    const urlRequest = request.url;

    if (urlRequest.split('/')[2] == 'viacep.com.br')
      return next.handle(request);
    
    if (authService.isAuthenticated() || authService.getUserTemp()) {
            
      let key = sessionStorage.getItem('icbeu:d3d25d546e528d346231cd242ab2f1d1');      
      let token = sessionStorage.getItem(key);

      if (!key) {
        authService.getUserTemp().subscribe(data => {
          token = data.accessToken;
        });
      }

      const authRequest = request.clone({setHeaders: {'Authorization': `Bearer ${token}`}});

      return next.handle(authRequest);
    } else {
      return next.handle(request);
    }


  }
}
